/**
 * «¿Cómo nos conociste?» (optional select on the contact and services forms).
 *
 * The chosen key travels to analytics as-is; for the owner's inbox it is
 * appended to the message as a Spanish line (internal emails stay in Spanish
 * whatever the site locale). No schema, API or D1 change: it rides inside
 * `message`, which `contactSchema` already caps at 4000 characters.
 */
/**
 * What a visitor may type in the message textarea: contactSchema caps `message` at
 * 4000 characters, minus room for the tags the forms add (`[Asesoría de imagen · <service name>] `,
 * up to ~70 characters on a service page, and `[Origen: …]`), so a long message never turns into a 422.
 */
export const MESSAGE_MAX_LENGTH = 3800;

export const CONTACT_SOURCES = ['google', 'maps', 'instagram', 'referral', 'event', 'press', 'other'] as const;

export type ContactSource = (typeof CONTACT_SOURCES)[number];

/** Fixed Spanish labels for the owner's inbox. */
export const CONTACT_SOURCE_LABELS: Record<ContactSource, string> = {
  google: 'Google',
  maps: 'Google Maps',
  instagram: 'Instagram',
  referral: 'Recomendación',
  event: 'Evento en tienda',
  press: 'Prensa',
  other: 'Otro',
};

export function isContactSource(value: string): value is ContactSource {
  return (CONTACT_SOURCES as readonly string[]).includes(value);
}

/** Appends `[Origen: <label>]` when `source` is a known key; otherwise returns `message` unchanged. */
export function withSource(message: string, source: string): string {
  return isContactSource(source) ? `${message}\n\n[Origen: ${CONTACT_SOURCE_LABELS[source]}]` : message;
}
